import TextStyle, { TextStyleProps } from '@able/react/dist/TextStyle';
import './style.scss';
import LoadingProgressSpinner from '../assets/images/loading-progress-spinner.svg';
import { ableTextAlias } from '../util/able-migration';

export type SpinnerProps = {
    id?: string;
    size: '16' | '24' | '48' | '96';
    label?: string;
    variant?: 'Horizontal' | 'Vertical';
    isLoading: boolean;
    centered?: boolean
    imageScreenReaderContent: string;
};

const Spinner = ({
    id,
    size,
    label,
    variant,
    isLoading,
    centered,
    imageScreenReaderContent
}: SpinnerProps) => {
    let wrapperClassName = 'ted-ui-spinner horizontal';
    if (variant === 'Vertical') {
        wrapperClassName = wrapperClassName.replace('horizontal','vertical');
    }
    if (centered) {
        wrapperClassName += ' centered' 
    }
    let imageClassName = '';
    if (size) imageClassName +=  size;

    const renderLabel = () => {
        let labelTextAlias = ableTextAlias("FinePrint");
        if (size === '48') labelTextAlias = ableTextAlias("TextBigBodyShort");
        if (size === '96') labelTextAlias = ableTextAlias("TextLeading");

        const labelProps = {
            alias: labelTextAlias,
            alignment:"Left",
            className: "ted-ui-spinner-label"
        }
        return (
            <div className={`ted-ui-spinner-label-wrapper size-${size}`}>
                <TextStyle
                    {...labelProps as TextStyleProps}
                >
                    <span>{label || ''}</span>
                </TextStyle>
            </div>
        )
    }
    const renderImage = () => {
        return (
            <div className='ted-ui-spinner-image'>
                {
                    !label &&
                    <span className="sr-only">{imageScreenReaderContent}</span>
                }
                <LoadingProgressSpinner
                    className={imageClassName} 
                    height={size}
                    width={size}
                />
            </div>
        )
    }
    if (!isLoading) {
        return null;
    }
    return (
        <div
            id={`ted-ui-spinner-id-${id}`}
            className={wrapperClassName}
            role='alert'
        >
            {
                renderImage()
            }
            {
                renderLabel()
            }
        </div>
    ) 
}

export default Spinner;
